//Teste AB - Cor do Badge

// const cartBadgeTest = () => {

//   sessionStorage.setItem('cartBadgeTest', 'true');
//   const cssClassColorChange = 'cart-count-bubble--red';

//   const apply = () => {
//     if (sessionStorage.getItem('cartBadgeTest') !== 'true') return;
//     document.querySelectorAll('.cart-count-bubble')
//       .forEach(el => el.classList.add(cssClassColorChange));
//   };
 
//   apply();

//   const cartBadgeColorChange = () => {
//     requestAnimationFrame(() => requestAnimationFrame(apply));
//   };

//   const formAddToCartButton = document.querySelectorAll('.form-add-to-cart-button');
//   const quickAddSubmit = document.querySelectorAll('.quick-add__submit');

//   if (formAddToCartButton.length === 0 && quickAddSubmit.length === 0) {
//   } else {
//     [...formAddToCartButton, ...quickAddSubmit].forEach((item) => {
//       item.addEventListener('click', cartBadgeColorChange);
//     });
//   }
  
//   document.addEventListener('click', (e) => {
//     if (e.target.closest('.drawer__close')) cartBadgeColorChange();
//   });

//   const target = document.querySelector('header') || document.body;
//   const mo = new MutationObserver(() => apply());
//   mo.observe(target, { childList: true, subtree: true });
  
//   window.addEventListener('cart:updated', apply);
//   window.addEventListener('drawer:open', cartBadgeColorChange);
//   window.addEventListener('drawer:close', cartBadgeColorChange);
// };

function changePromoBarContent() {
    const promoBar = document.querySelector(".announcement-bar__message");
    promoBar.innerHTML = '<span style="color: #FFF; font-size: 0.85em"><b>Nunca mais fique sem café especial.<a href="https://coffeemais.com/pages/assinatura-de-cafe" style="color:#FF6600;text-decoration: none;"> SAIBA ++</a></b></span>';
}